import { Col3Col9, Radio } from '@aon/aon-tws-common-ui';
import globalVars from '@aon/aon-tws-common-ui/build/lib/globalVars.module.scss';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';
import { AccessCodeType } from '../../../models/AccessCodeType';
import { IApplicationState } from '../../../store';
import { ActionCreators } from '../../../store/AudienceDetailsStore';
import { BodyCopyMedium, LabelMedium } from '../../common/styles/globalStyles';

const AccessCodeContainer = styled.div.attrs<{ disabled?: boolean }>({
	className: 'tws-accesscode-container',
	'data-testid': 'tws-accesscode-container',
})<{ disabled?: boolean }>`
	 {
		background-color: ${(props) => (props.disabled === undefined || !props.disabled ? 'unset' : globalVars.gray9)};
		padding: 16px;
		border-radius: 3px;
	}
`;
AccessCodeContainer.displayName = 'AccessCodeContainer';

const Pill = styled.div.attrs<{ disabled?: boolean }>({
	className: 'tws-accesscode-pill',
	'data-testid': 'tws-accesscode-pill',
})<{ disabled?: boolean }>`
	 {
		background-color: ${(props) => (props.disabled === undefined || !props.disabled ? globalVars.gray8 : '#D6F0E1')};
		color: ${(props) => (props.disabled === undefined || !props.disabled ? globalVars.secondaryGray2 : '#0D6833')};
		display: inline-block;
		font-weight: ${globalVars.fontWeightNormal};
		border-radius: 10.5px;
		font-size: 11px;
		height: 21px;
		padding: 0 12px;
		div {
			height: 100%;
			position: relative;
			display: flex;
			align-items: center;
		}
	}
`;
Pill.displayName = 'Pill';

const MediumLabel = styled(LabelMedium).attrs<{}>({
	className: 'tws-accesscode-label',
	'data-testid': 'tws-accesscode-label',
})<{}>`
	 {
		display: inline;
		margin-right: 10px;
		vertical-align: middle;
	}
`;
MediumLabel.displayName = 'MediumLabel';

const MediumBodyCopy = styled(BodyCopyMedium).attrs<{}>({
	className: 'tws-accesscode-body',
	'data-testid': 'tws-accesscode-body',
})<{}>`
	 {
		margin-top: 10px;
	}
`;
MediumBodyCopy.displayName = 'MediumBodyCopy';

const RadioContainer = styled.div.attrs<{}>({
	className: 'tws-accesscode-radio',
	'data-testid': 'tws-accesscode-radio',
})<{}>`
	 {
		margin-top: 20px;
	}
`;
RadioContainer.displayName = 'RadioContainer';

const autogeneratedLowerCase = ContentConstants.ACCESS_CODE_TYPES_AUTOGENERATED.toLowerCase();
const customLowerCase = ContentConstants.ACCESS_CODE_TYPES_CUSTOM.toLowerCase();

export const AccessCodes = (props: { labelSize?: 'sm' | 'md' | 'lg' }) => {
	const { audience } = useSelector((state: IApplicationState) => state.audienceDetails);
	const dispatch = useDispatch();
	const accessCodeType = audience.accessCodeType;
	const currentAccessCodeType = accessCodeType === AccessCodeType.Autogenerated ? autogeneratedLowerCase : customLowerCase;

	const accessCodeOptions = [
		{ name: autogeneratedLowerCase, displayText: ContentConstants.ACCESS_CODE_TYPES_AUTOGENERATED },
		{ name: customLowerCase, displayText: ContentConstants.ACCESS_CODE_TYPES_CUSTOM },
	];

	return (
		<Col3Col9 label={ContentConstants.ACCESS_CODES_TITLE} labelSize={props.labelSize}>
			<RadioContainer>
				<Radio name='radioAccessCodes' items={accessCodeOptions} value={currentAccessCodeType} onChange={onChangeHandler} />
			</RadioContainer>
		</Col3Col9>
	);

	function onChangeHandler(value: any) {
		let accessCodeOption = undefined;
		if (value === autogeneratedLowerCase) {
			accessCodeOption = AccessCodeType.Autogenerated;
		} else if (value === customLowerCase) {
			accessCodeOption = AccessCodeType.Custom;
		}
		dispatch(ActionCreators.HandleAccessCodeTypeChange(accessCodeOption));
	}
};
